export default "__VITE_ASSET__DiM6C26___"